// extracted by mini-css-extract-plugin
export default {"root":"gsdZR","tablet":"S793O"};